import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TokenService } from '../services/token.service';
import { environment } from '../../environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private tokenService: TokenService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const ofacServiceUrl = environment.ofacService.url;

    if (request.url.startsWith(ofacServiceUrl)) {
      const headers: { [key: string]: string } = {};

      if (environment.apim?.subscriptionKey) {
        headers['Ocp-Apim-Subscription-Key'] = environment.apim.subscriptionKey;
      }

      headers['Api-Version'] = environment.ofacService.version;

      const token = this.tokenService.getAccessToken();
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }

      if (Object.keys(headers).length > 0) {
        const clonedRequest = request.clone({
          setHeaders: headers
        });
        return next.handle(clonedRequest);
      }
    }

    return next.handle(request);
  }
}
